/**
 * Class to work as a DTO to hold the information of a event dispatched to Google Analytics 4.
 */
class GoogleAnalytics4Event {
  constructor(eventName, params = {}) {
    this.eventName = eventName;
    this.params = params;
    this.event = 'GA4Event';
  }

  /**
   * The function returns the value of the eventName property.
   * @returns The value of the variable `eventName`.
   */
  getEventName() {
    return this.eventName;
  }

  /**
   * The function returns the value of the "params" property.
   * @returns The `params` property is being returned.
   */
  getParams() {
    return this.params;
  }
}

export default GoogleAnalytics4Event;
